import { render, staticRenderFns } from "./AdminLeads.vue?vue&type=template&id=19763905&scoped=true&"
import script from "./AdminLeads.vue?vue&type=script&lang=js&"
export * from "./AdminLeads.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeads.vue?vue&type=style&index=0&id=19763905&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19763905",
  null
  
)

export default component.exports